import script from "./CitasHistoryCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CitasHistoryCard.vue?vue&type=script&setup=true&lang=js"

import "./CitasHistoryCard.vue?vue&type=style&index=0&id=4d83aaef&scoped=true&lang=scss"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d83aaef"]])

export default __exports__